<template>
    <main id="machine-sheet-arguments" v-if="displayContent">
        <div class="wrapper">
            <div class="arguments" v-if="themeArguments.length > 0">
                <h2 class="title is-2">{{ $t("arguments") }}</h2>

<!--                <p class="intro-text">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do<br/>
                    eiusmod tempor incididunt ut labore et dolore
                </p>-->
                <div class="tabs-container">
                    <div class="arguments-switcher" v-if="(themeArguments && themeArguments.length > 0) && (counterArguments && counterArguments.length > 0)">
                        <a class="switcher-tab" @click="switchTab('all_arguments')" :class="{'selected': selectedTab === 'all_arguments'}">{{ $t("all_arguments") }}</a>
                        <a class="switcher-tab" @click="switchTab('counter_arguments')" :class="{'selected': selectedTab === 'counter_arguments'}">{{ $t("counter_arguments") }}</a>
                    </div>
                    <div class="all-arguments" v-if="selectedTab === 'all_arguments'">
                        <div class="arguments-selects">
                            <label class="colored-label" :class="brandColor">{{ $t("theme") }}</label>
        <!--                    <b-select v-model="selectedTheme" :placeholder="$t('select_theme')" size="is-large" expanded rounded>
                                <option
                                    v-for="theme in themeArguments"
                                    :key="theme.code"
                                    :value="theme"
                                >{{ theme.name }}</option>
                            </b-select>-->
                            <b-select v-model="selectedTheme" :placeholder="$t('select_theme')" size="is-large" expanded rounded>
                                <option
                                    v-for="theme in themeArguments"
                                    :key="theme.id"
                                    :value="theme"
                                >{{ theme.values.name }}</option>
                            </b-select>

                            <label class="colored-label" :class="brandColor">{{ $t("argument") }}</label>
        <!--                    <b-select v-model="selectedArgument" :placeholder="$t('select_argument')" size="is-large" expanded rounded :disabled="!selectedTheme">
                                <option
                                    v-for="argument in argumentsOfTheme"
                                    :value="argument"
                                >{{ argument.argument_title }}</option>
                            </b-select>-->
                            <b-select v-model="selectedArgument" :placeholder="$t('select_argument')" size="is-large" expanded rounded :disabled="!selectedTheme">
                              <option
                                  :value="{value: 'all'}"
                              >{{ $t('all_arguments') }}</option>
                              <option
                                    v-for="argument in argumentsOfTheme"
                                    :value="argument"
                                    v-html="argument.values.title"
                                ></option>
                            </b-select>
                        </div>

                        <template v-if="selectedArgument && selectedArgument.value === 'all'">
                          <div class="argument-details" v-for="arg in argumentsOfTheme">
                            <span class="innovation-badge" :class="brandBackgroundColor" v-if="arg.innovation">
                                {{ $t("innovation_brand", {brand: 'Manitou'}) }}
                            </span>
                            <!--<h2 class="title" :class="brandColor">{{ selectedArgument.argument_title }}</h2>
                            <p class="intro" v-html="selectedArgument.argument_description"></p>

                            <div
                                v-for="benefit in benefits"
                                :key="benefit.code"
                                class="benefit"
                                v-if="selectedArgument[benefit.code]"
                            >
                                <h3 class="subtitle">{{ benefit.label }}</h3>
                                <p class="text" v-html="selectedArgument[benefit.code]"></p>
                            </div>-->
                            <h2 class="title" :class="brandColor" v-html="arg.values.title"></h2>
                            <p class="intro" v-html="arg.values.description"></p>
                            <div class="benefit" v-if="arg.values.benefit_1">
                              <h3 class="subtitle">{{ $t('benefits') }}</h3>
                              <p class="text" v-html="arg.values.benefit_1"></p>
                              <p class="text" v-if="arg.values.benefit_2" v-html="arg.values.benefit_2"></p>
                              <p class="text" v-if="arg.values.benefit_3" v-html="arg.values.benefit_3"></p>
                            </div>
                            <div class="benefit" v-if="arg.values.benefits_tco">
                              <h3 class="subtitle">{{ $t('benefits') }} tco</h3>
                              <p class="text" v-html="arg.values.benefits_tco"></p>
                            </div>
                            <div class="benefit" v-if="arg.values.benefits_risks">
                              <h3 class="subtitle">{{ $t('benefits') }} risks</h3>
                              <p class="text" v-html="arg.values.benefits_risks"></p>
                            </div>
                            <div class="benefit" v-if="arg.values.benefits_coach">
                              <h3 class="subtitle">{{ $t('benefits') }} coach</h3>
                              <p class="text" v-html="arg.values.benefits_coach"></p>
                            </div>
                          </div>
                        </template>

                        <div class="argument-details" v-else-if="selectedArgument">
                            <span class="innovation-badge" :class="brandBackgroundColor" v-if="selectedArgument.innovation">
                                {{ $t("innovation_brand", {brand: 'Manitou'}) }}
                            </span>
        <!--                    <h2 class="title" :class="brandColor">{{ selectedArgument.argument_title }}</h2>
                            <p class="intro" v-html="selectedArgument.argument_description"></p>

                            <div
                                v-for="benefit in benefits"
                                :key="benefit.code"
                                class="benefit"
                                v-if="selectedArgument[benefit.code]"
                            >
                                <h3 class="subtitle">{{ benefit.label }}</h3>
                                <p class="text" v-html="selectedArgument[benefit.code]"></p>
                            </div>-->
                            <h2 class="title" :class="brandColor" v-html="selectedArgument.values.title"></h2>
                            <p class="intro" v-html="selectedArgument.values.description"></p>
                            <div class="benefit" v-if="selectedArgument.values.benefit_1">
                                <h3 class="subtitle">{{ $t('benefits') }}</h3>
                                <p class="text" v-html="selectedArgument.values.benefit_1"></p>
                                <p class="text" v-if="selectedArgument.values.benefit_2" v-html="selectedArgument.values.benefit_2"></p>
                                <p class="text" v-if="selectedArgument.values.benefit_3" v-html="selectedArgument.values.benefit_3"></p>
                            </div>
                            <div class="benefit" v-if="selectedArgument.values.benefits_tco">
                                <h3 class="subtitle">{{ $t('benefits') }} tco</h3>
                                <p class="text" v-html="selectedArgument.values.benefits_tco"></p>
                            </div>
                            <div class="benefit" v-if="selectedArgument.values.benefits_risks">
                                <h3 class="subtitle">{{ $t('benefits') }} risks</h3>
                                <p class="text" v-html="selectedArgument.values.benefits_risks"></p>
                            </div>
                            <div class="benefit" v-if="selectedArgument.values.benefits_coach">
                                <h3 class="subtitle">{{ $t('benefits') }} coach</h3>
                                <p class="text" v-html="selectedArgument.values.benefits_coach"></p>
                            </div>
                        </div>
                    </div>
                    <div class="counter-arguments" v-if="selectedTab === 'counter_arguments'">
                        <div class="arguments-list">
                            <div class="argument-item" v-for="objection in counterArguments" :key="objection.id">
                                <div class="counter-argument">
                                    <label class="colored-label" :class="brandColor">{{ $t("comments") }}</label>
                                    <div class="argument-text">
                                        <p v-html="objection.values.counter"></p>
                                    </div>
                                </div>
                                <div class="argument">
                                    <label class="colored-label">{{ $t("manitou_answer") }}</label>
                                    <div class="argument-text">
                                      <p v-html="objection.values.benefit"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-available-soon" v-else>
                {{ $t('content_available_soon') }}
            </div>
        </div>
    </main>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

    import productService from '@/services/akeneo/product'
    import attributeService from '@/services/akeneo/attribute'
    import compendiumService from '@/services/salesbox/compendium';
    import serliProductService from '@/services/serli/product';

    export default {
        name: 'MachineArgumentsView',
        data() {
            return {
                displayContent: false,
                themeArguments: [],
                selectedTheme: null,
                selectedArgument: null,
                benefits: [],
                selectedTab: null,
                counterArguments: [],
            }
        },
        watch: {
            selectedTheme() {
                this.selectedArgument = {value: 'all'};
            }
        },
        computed: {
            ...mapState({
                productDatas: state => state.sheet.productDatas
            }),
            ...mapGetters({
              localeKebabFormat: 'settings/localeKebabFormat'
            }),
            argumentsOfTheme() {
                if(this.selectedTheme)
                    return this.selectedTheme.list;
                return [];
            },
        },
        created(){
          // this.fetchAllData();
          this.getAllData();
            /*this.startLoading();
            this.getArguments()
            .then(() => this.getBenefits())
            .finally(() => {
                this.displayContent = true;
                this.stopLoading();
            });*/
        },
        methods: {
            async getAllData() {
                this.startLoading();
                let themeArgs = [];
                let counterArgs = [];
                await serliProductService.getCompendium(this.productDatas.identifier, {locale: this.localeKebabFormat})
                    .then(response => {
                      console.log('get args');
                        // let args = require('@/common/utils/arguments.json');
                        // console.log(args);
                        // this.themeArguments = args;
                        let data = response.data.data;
                        data.arguments.forEach(arg => {
                            arg.families.forEach(theme => {
                                theme.list = [];
                                const themeIndex = themeArgs.findIndex(x => x.id === theme.id);
                                if (themeIndex === -1) {
                                    theme.list.push(arg);
                                    themeArgs.push(theme);
                                } else {
                                    themeArgs[themeIndex].list.push(arg);
                                    /*if (theme.list.findIndex(x => x.id === arg.id) !== -1) {
                                      console.log('else push');
                                      theme.list.push(arg);
                                    }*/
                                }
                            });
                        });
                        counterArgs = data.objections;
                    })
                    .finally(() => {
                      this.themeArguments = themeArgs;
                      this.counterArguments = counterArgs;
                      if (!this.themeArguments) {
                        this.selectedTab = 'counter_arguments';
                      } else this.selectedTab = 'all_arguments';
                      this.displayContent = true;
                      this.stopLoading();
                    });
                    // console.log(themeArgs);
            },
          fetchAllData() {

            let themeArgs = [];
            let counterArgs = [];

                  let data = this.productDatas.compendium;
                  data.arguments.forEach(arg => {
                    arg.families.forEach(theme => {
                      theme.list = [];
                      const themeIndex = themeArgs.findIndex(x => x.id === theme.id);
                      if (themeIndex === -1) {
                        theme.list.push(arg);
                        themeArgs.push(theme);
                      } else {
                        themeArgs[themeIndex].list.push(arg);
                        /*if (theme.list.findIndex(x => x.id === arg.id) !== -1) {
                          console.log('else push');
                          theme.list.push(arg);
                        }*/
                      }
                    });
                  });
                  counterArgs = data.objections;

                  this.themeArguments = themeArgs;
                  this.counterArguments = counterArgs;
                  if (!this.themeArguments) {
                    this.selectedTab = 'counter_arguments';
                  } else this.selectedTab = 'all_arguments';
                  this.displayContent = true;

          },
            /*getArguments(){
                if(this.productDatas.associations.arguments_machines){
                    let promisesArray = [];

                    for(const argument of this.productDatas.associations.arguments_machines.products) {
                        promisesArray.push(productService.show(argument, {
                            locale: this.$store.state.settings.locale
                        }));
                    }

                    return Promise.all(promisesArray).then(async responses => {
                        let themeArguments = [];
                        for(const response of responses) {
                            const responseDatas = response.data.data;

                            for (const theme of responseDatas.values.theme) {
                                if (!themeArguments.find(x => x.code === theme)) {
                                    let themeDatas = await attributeService.option('theme', theme, { locale: this.$store.state.settings.locale }).then(data => data.data.data.labels);
                                    themeArguments.push({
                                        code: theme,
                                        name: themeDatas,
                                        list: []
                                    });
                                }
                                let themeArgumentIndex = themeArguments.findIndex(x => x.code === theme);
                                themeArguments[themeArgumentIndex].list.push(Object.assign(responseDatas.values, {code: responseDatas.identifier}))
                            }
                        }
                        this.themeArguments = themeArguments;
                    });
                }
                else {
                    return Promise.resolve();
                }
            },*/
            /*getBenefits(){
                let promisesArray = [];
                const benefitCodes = ['benefits_arg', 'benefits_arg_tco', 'benefits_arg_risk', 'benefits_arg_coach', 'advice'];
                for(const benefitCode of benefitCodes) {
                    promisesArray.push(attributeService.show(benefitCode, {
                        locale: this.$store.state.settings.locale
                    }));
                }

                return Promise.all(promisesArray).then(responses => {
                    let benefits = [];
                    for(const response of responses)
                        benefits.push(response.data.data)
                    this.benefits = benefits;
                });
            },*/
            switchTab(code) {
                if (code !== this.selectedTab)
                  this.selectedTab = code;
            }
        }
    }
</script>

<style lang="scss">
#machine-sheet-arguments {
    padding-top: 35px;
    padding-bottom: 40px;

    .arguments {
        .title {
            margin-bottom: 10px;
        }

        .intro-text {
            @include standard-text-grey;
        }

        .tabs-container {
            max-width: 1920px;

            .all-arguments {
                padding: 0 12px;

              @media #{$mq_phone_min}{
                padding: 10px 48px;
              }
            }
        }

        .arguments-switcher {
          border-radius: 32px;
          background-color: #F1F1F1;
          margin: 28px auto;
          color: #000000;
          width: auto;
          max-width: 400px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px;

          @media #{$mq_phone} {
            width: 100%;
          }

          .switcher-tab {
            font-size: 13px;
            font-weight: bold;
            letter-spacing: 0.9px;
            line-height: 15px;
            text-align: center;
            padding: 8px 14px;
            text-transform: uppercase;
            opacity: 0.5;

            &.selected {
              border-radius: 24px;
              background-color: #101010;
              color: #FFFFFF;
              opacity: 1;
            }
          }
        }

        .arguments-selects {
            width: 460px;
            margin: 30px 0;

            @media #{$mq_phone} {
                width: 100%;
            }

            .colored-label {
                margin-left: 15px;
            }

          div.control:first-of-type {
            max-width: 280px;

            @media #{$mq_phone} {
              max-width: 100%;
            }
          }
        }

        .argument-details {
            position: relative;
            max-width: 885px;
            padding: 30px 100px 30px 30px;
            background-color: $light-grey;
            margin-bottom: 15px;

            @media #{$mq_phone} {
                margin-top: 60px;
                margin-bottom: 0;
                padding: 20px 40px 20px 20px;
            }

            .innovation-badge {
                position: absolute;
                top: 0;
                right: 0;
                display: inline-block;
                padding: 8px 8px 6px 8px;
                font-size: 13px;
                font-weight: 700;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                color: $white;
                transform: rotate(-90deg);
                transform-origin: bottom right;

                @media #{$mq_phone} {
                    padding: 3px 4px 2px 4px;
                    font-size: 9px;
                }
            }

            .title {
                @include medium-title;
                margin-bottom: 15px;
            }

            .intro {
                font-size: 15px;
                line-height: 20px;
                color: $medium-grey;
            }

            .subtitle {
                margin: 30px 0 10px;
                font-size: 16px;
                font-weight: 700;
                text-transform: uppercase;
            }

            .text {
                font-size: 15px;
                line-height: 26px;
                color: $medium-grey;
            }
        }

        .arguments-list {
            display: flex;
            flex-direction: column;
            justify-content: center;

            .argument-item {
              margin: 0 0 40px;
              display: flex;
              justify-content: space-between;
              align-items: flex-start;

                @media #{$mq_phone} {
                  flex-wrap: wrap;
                }

                .argument, .counter-argument {
                  padding: 0 8px;
                  flex-basis: 50%;

                  @media #{$mq_phone} {
                    flex: 1 0 100%;
                  }
                }

                .colored-label {
                  margin-top: 0;
                }
            }

            .argument-text {
              margin: 20px 0;
              border-radius: 20px;
              background-color: #F1F1F1;
              padding: 20px;
            }
        }
    }
}
</style>
